import { c as _c } from "react/compiler-runtime";
import { useInView } from 'framer-motion';
import React, { PropsWithChildren, useRef } from 'react';
interface AnimatedContentProps {
  className?: string;
}
export const AnimatedContent = t0 => {
  const $ = _c(10);
  const {
    className,
    children
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isInView = useInView(ref, t1);
  const t2 = isInView ? "none" : "translateY(100px)";
  const t3 = isInView ? 1 : 0;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = {
      transform: t2,
      opacity: t3,
      transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children || $[5] !== t4) {
    t5 = <div style={t4} className="will-change-transform">{children}</div>;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== className || $[8] !== t5) {
    t6 = <section ref={ref} className={className}>{t5}</section>;
    $[7] = className;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};